import styled from 'styled-components'

type SpacerProps = {
  width?: number | string
  height?: number | string
  block?: boolean
}

const Spacer = styled.span<SpacerProps>`
  display: ${({ block }) => (block ? 'block' : 'initial')};
  min-width: ${({ width }) => width ?? 0}px;
  min-height: ${({ height }) => height ?? 0}px;
`

export default Spacer
